"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareAddCustomerAddressResponse = prepareAddCustomerAddressResponse;
exports.prepareAddFavoriteMenuItemResponse = prepareAddFavoriteMenuItemResponse;
exports.prepareCustomerAddressesResponse = prepareCustomerAddressesResponse;
exports.prepareDiningChoicesResponse = prepareDiningChoicesResponse;
exports.prepareEditFavoriteMenuItemResponse = prepareEditFavoriteMenuItemResponse;
exports.prepareFavoriteMenuItemsResponse = prepareFavoriteMenuItemsResponse;
exports.prepareGetMenuGroupResponse = prepareGetMenuGroupResponse;
exports.prepareGglocationMenuGroupsResponse = prepareGglocationMenuGroupsResponse;
exports.prepareGglocationsResponse = prepareGglocationsResponse;
exports.prepareImagesResponse = prepareImagesResponse;
exports.prepareIngredientsResponse = prepareIngredientsResponse;
exports.prepareLandingPageResponse = prepareLandingPageResponse;
exports.prepareMenuGroupsResponse = prepareMenuGroupsResponse;
exports.prepareNutritionalCalculationResponse = prepareNutritionalCalculationResponse;
exports.prepareOrdersResponse = prepareOrdersResponse;
exports.preparePlaceOrderResponse = preparePlaceOrderResponse;
exports.preparePricingVariationsResponse = preparePricingVariationsResponse;
exports.prepareRemoveCustomerAddressResponse = prepareRemoveCustomerAddressResponse;
exports.prepareRemoveFavoriteMenuItemResponse = prepareRemoveFavoriteMenuItemResponse;
exports.prepareServingNumberVariationsResponse = prepareServingNumberVariationsResponse;
exports.prepareSettingsResponse = prepareSettingsResponse;
exports.prepareStoreBusyResponse = prepareStoreBusyResponse;
exports.prepareUnavailableIngredientsResponse = prepareUnavailableIngredientsResponse;
exports.responseArrayToObject = responseArrayToObject;
var _lodash = require("lodash");
var commonUtils = _interopRequireWildcard(require("./commonUtils"));
var foodUtils = _interopRequireWildcard(require("./foodUtils"));
var orderUtils = _interopRequireWildcard(require("./orderUtils"));
var gglocationUtils = _interopRequireWildcard(require("./gglocationUtils"));
var _Gglocation = _interopRequireDefault(require("../Gglocation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function prepareOrdersResponse(_ref) {
  var data = _ref.data,
    state = _ref.state,
    requestOptions = _ref.requestOptions;
  var _data$apiSettings = data.apiSettings,
    countryName = _data$apiSettings.countryName,
    countryCodeAlpha3 = _data$apiSettings.countryCodeAlpha3;
  var _data$response = data.response,
    count = _data$response.count,
    previous = _data$response.previous,
    next = _data$response.next,
    results = _data$response.results;
  var _orderUtils$parseBack = orderUtils.parseBackendOrders(results, countryName, countryCodeAlpha3),
    nextUserOrders = _orderUtils$parseBack.userOrders,
    nextUserOrderIds = _orderUtils$parseBack.userOrderIds,
    userOrderMenuItems = _orderUtils$parseBack.userOrderMenuItems;
  var userOrders = {};
  var userOrderIds = [];
  if (requestOptions.clearPrevious) {
    // Remove existing state records
    userOrders = nextUserOrders;
    userOrderIds = nextUserOrderIds;
  } else {
    userOrders = _objectSpread(_objectSpread({}, state.userOrders), nextUserOrders);
    userOrderIds = (0, _lodash.uniq)([].concat(_toConsumableArray(state.userOrderIds), _toConsumableArray(nextUserOrderIds)));
  }
  var userOrdersList = userOrderIds.map(function (userOrderId) {
    return userOrders[userOrderId];
  });
  var _orderUtils$userOrder = orderUtils.userOrdersGglocations(userOrdersList),
    mostFrequentGglocationIds = _orderUtils$userOrder.mostFrequentGglocationIds,
    mostRecentGglocationIds = _orderUtils$userOrder.mostRecentGglocationIds;
  return {
    response: {
      userOrders: userOrders,
      userOrderIds: userOrderIds,
      userOrderMenuItems: userOrderMenuItems,
      mostFrequentGglocationIds: mostFrequentGglocationIds,
      mostRecentGglocationIds: mostRecentGglocationIds,
      pageInfo: _objectSpread(_objectSpread({}, state.pageInfo), {}, {
        orders: {
          count: count,
          previous: previous,
          next: next,
          currentPage: requestOptions.page
        }
      })
    }
  };
}
function preparePlaceOrderResponse(_ref2) {
  var data = _ref2.data,
    state = _ref2.state;
  var _data$apiSettings2 = data.apiSettings,
    countryName = _data$apiSettings2.countryName,
    countryCodeAlpha3 = _data$apiSettings2.countryCodeAlpha3;
  var _orderUtils$parseBack2 = orderUtils.parseBackendOrders([data.response], countryName, countryCodeAlpha3),
    userOrders = _orderUtils$parseBack2.userOrders,
    userOrderIds = _orderUtils$parseBack2.userOrderIds,
    userOrderMenuItems = _orderUtils$parseBack2.userOrderMenuItems;
  userOrders = _objectSpread(_objectSpread({}, state.userOrders), userOrders);
  userOrderIds = [].concat(_toConsumableArray(state.userOrderIds), _toConsumableArray(userOrderIds));
  var userOrdersList = userOrderIds.map(function (userOrderId) {
    return userOrders[userOrderId];
  });
  var _orderUtils$userOrder2 = orderUtils.userOrdersGglocations(userOrdersList),
    mostFrequentGglocationIds = _orderUtils$userOrder2.mostFrequentGglocationIds,
    mostRecentGglocationIds = _orderUtils$userOrder2.mostRecentGglocationIds;
  return {
    response: {
      userOrders: userOrders,
      userOrderIds: userOrderIds,
      mostFrequentGglocationIds: mostFrequentGglocationIds,
      mostRecentGglocationIds: mostRecentGglocationIds,
      userOrderMenuItems: _objectSpread(_objectSpread({}, state.userOrderMenuItems), userOrderMenuItems)
    }
  };
}
function prepareAddFavoriteMenuItemResponse(_ref3) {
  var data = _ref3.data,
    state = _ref3.state;
  var _foodUtils$parseCusto = foodUtils.parseCustomerFavoriteMenu(data.response),
    favoriteMenuItem = _foodUtils$parseCusto.favoriteMenuItem,
    ingredientServings = _foodUtils$parseCusto.ingredientServings;
  return {
    response: {
      favoriteMenuItems: _objectSpread(_objectSpread({}, state.favoriteMenuItems), {}, _defineProperty({}, favoriteMenuItem.id, favoriteMenuItem)),
      favoriteMenuItemIngredientServings: _objectSpread(_objectSpread({}, state.favoriteMenuItemIngredientServings), {}, _defineProperty({}, favoriteMenuItem.id, ingredientServings)),
      favoriteMenuItemIds: [].concat(_toConsumableArray(state.favoriteMenuItemIds), [favoriteMenuItem.id])
    }
  };
}
function prepareEditFavoriteMenuItemResponse(_ref4) {
  var data = _ref4.data,
    state = _ref4.state;
  var _foodUtils$parseCusto2 = foodUtils.parseCustomerFavoriteMenu(data.response),
    favoriteMenuItem = _foodUtils$parseCusto2.favoriteMenuItem;
  return {
    response: {
      favoriteMenuItems: _objectSpread(_objectSpread({}, state.favoriteMenuItems), {}, _defineProperty({}, favoriteMenuItem.id, favoriteMenuItem))
    }
  };
}
function prepareFavoriteMenuItemsResponse(_ref5) {
  var data = _ref5.data,
    state = _ref5.state,
    requestOptions = _ref5.requestOptions;
  var favoriteMenuItems = {};
  var favoriteMenuItemIds = [];
  var favoriteMenuItemIngredientServings = {};
  if (!requestOptions.clearPrevious) {
    favoriteMenuItems = state.favoriteMenuItems || {};
    favoriteMenuItemIds = state.favoriteMenuItemIds || [];
    favoriteMenuItemIngredientServings = state.favoriteMenuItemIngredientServings || {};
  }
  var _data$response2 = data.response,
    count = _data$response2.count,
    previous = _data$response2.previous,
    next = _data$response2.next,
    results = _data$response2.results;
  results.map(function (favoriteMenuItem) {
    var result = foodUtils.parseCustomerFavoriteMenu(favoriteMenuItem);
    favoriteMenuItems[favoriteMenuItem.id] = result.favoriteMenuItem;
    favoriteMenuItemIds.push(favoriteMenuItem.id);
    favoriteMenuItemIngredientServings[favoriteMenuItem.id] = result.frontendIngredientServings;
    return favoriteMenuItem;
  });
  return {
    response: {
      favoriteMenuItems: favoriteMenuItems,
      favoriteMenuItemIngredientServings: favoriteMenuItemIngredientServings,
      favoriteMenuItemIds: (0, _lodash.uniq)(favoriteMenuItemIds),
      pageInfo: _objectSpread(_objectSpread({}, state.pageInfo), {}, {
        favoriteMenuItems: {
          count: count,
          previous: previous,
          next: next,
          currentPage: requestOptions.page
        }
      })
    }
  };
}
function prepareRemoveFavoriteMenuItemResponse(_ref6) {
  var state = _ref6.state,
    requestOptions = _ref6.requestOptions;
  var favoriteMenuItemIds = state.favoriteMenuItemIds.filter(function (id) {
    return id !== requestOptions.id;
  });
  var favoriteMenuItems = {};
  favoriteMenuItemIds.forEach(function (id) {
    favoriteMenuItems[id] = state.favoriteMenuItems[id];
  });
  return {
    response: {
      favoriteMenuItems: favoriteMenuItems,
      favoriteMenuItemIds: favoriteMenuItemIds
    }
  };
}
function prepareUnavailableIngredientsResponse(_ref7) {
  var data = _ref7.data;
  var gglocationDisabledIngredients = {};
  data.response.forEach(function (ingredient) {
    var gglocationKey = "".concat(ingredient.gglocationType, "_").concat(ingredient.gglocationId);
    if (gglocationDisabledIngredients[gglocationKey]) {
      gglocationDisabledIngredients[gglocationKey].push(ingredient.ingredient);
    } else {
      gglocationDisabledIngredients[gglocationKey] = [ingredient.ingredient];
    }
  });
  return {
    response: {
      gglocationDisabledIngredients: gglocationDisabledIngredients
    }
  };
}
var parseCustomerAddressCoordinates = function parseCustomerAddressCoordinates(_ref8) {
  var coordinates = _ref8.coordinates;
  var regex = /[+-]?\d+(\.\d+)?/g;
  var coordinatesPair = coordinates.match(regex).map(parseFloat);
  return {
    lat: coordinatesPair[2],
    lng: coordinatesPair[1]
  };
};
var parseCustomerAddress = function parseCustomerAddress(customerAddress, countryName, countryCodeAlpha3) {
  var deliveryAddress = commonUtils.parseDeliveryAddress(customerAddress, countryName, countryCodeAlpha3);
  return _objectSpread(_objectSpread({}, deliveryAddress), {}, {
    id: customerAddress.id,
    isDefault: customerAddress.isDefault,
    providerReference: customerAddress.providerReference,
    coordinates: parseCustomerAddressCoordinates(customerAddress)
  });
};
function prepareCustomerAddressesResponse(_ref9) {
  var data = _ref9.data;
  var _data$apiSettings3 = data.apiSettings,
    countryName = _data$apiSettings3.countryName,
    countryCodeAlpha3 = _data$apiSettings3.countryCodeAlpha3;
  var customerAddresses = {};
  var customerAddressIds = new Set();
  data.response.map(function (customerAddress) {
    customerAddresses[customerAddress.id] = parseCustomerAddress(customerAddress, countryName, countryCodeAlpha3);
    customerAddressIds.add(customerAddress.id);
    return customerAddress;
  });
  return {
    response: {
      customerAddresses: customerAddresses,
      customerAddressIds: _toConsumableArray(customerAddressIds)
    }
  };
}
function prepareAddCustomerAddressResponse(_ref10) {
  var data = _ref10.data,
    state = _ref10.state;
  var _data$apiSettings4 = data.apiSettings,
    countryName = _data$apiSettings4.countryName,
    countryCodeAlpha3 = _data$apiSettings4.countryCodeAlpha3;
  var customerAddress = parseCustomerAddress(data.response, countryName, countryCodeAlpha3);
  return {
    response: {
      customerAddresses: _objectSpread(_objectSpread({}, state.customerAddresses), {}, _defineProperty({}, customerAddress.id, customerAddress)),
      customerAddressIds: commonUtils.removeDuplicates([].concat(_toConsumableArray(state.customerAddressIds), [customerAddress.id]))
    }
  };
}
function prepareRemoveCustomerAddressResponse(_ref11) {
  var state = _ref11.state,
    requestOptions = _ref11.requestOptions;
  var customerAddressIds = state.customerAddressIds.filter(function (customerAddressId) {
    return customerAddressId !== requestOptions.customerAddressId;
  });
  var customerAddresses = {};
  customerAddressIds.forEach(function (customerAddressId) {
    customerAddresses[customerAddressId] = state.customerAddresses[customerAddressId];
  });
  return {
    response: {
      customerAddresses: customerAddresses,
      customerAddressIds: customerAddressIds
    }
  };
}
function prepareDiningChoicesResponse(_ref12) {
  var data = _ref12.data;
  var response = data.response;
  return response.reduce(function (diningChoiceOptions, diningChoiceOption) {
    var deliveryPartner = function () {
      if (!diningChoiceOption.deliveryPartner) {
        return null;
      }
      return {
        baseFee: diningChoiceOption.deliveryPartner.baseFee,
        minimumOrderTotal: diningChoiceOption.deliveryPartner.minimumOrderTotal
      };
    }();
    return {
      response: {
        diningChoiceOptions: _objectSpread(_objectSpread({}, diningChoiceOptions.response.diningChoiceOptions), {}, _defineProperty({}, commonUtils.toCamelCaseString(diningChoiceOption.slug), {
          id: diningChoiceOption.id,
          diningType: diningChoiceOption.diningType,
          isDineIn: diningChoiceOption.isDineIn,
          deliveryPartner: deliveryPartner
        }))
      }
    };
  }, {
    response: {
      diningChoiceOptions: {}
    }
  });
}
function prepareGglocationsResponse(_ref13) {
  var data = _ref13.data;
  var parsedStores = gglocationUtils.parseInstantGglocations(data.response.stores);
  var parsedPartners = gglocationUtils.parseTimeSlotGglocations(data.response.partners);
  var parsedGglocations = _objectSpread(_objectSpread({}, parsedStores.gglocations), parsedPartners.gglocations);
  var storeIds = Object.keys(parsedStores.gglocations);
  var partnerIds = Object.keys(parsedPartners.gglocations);
  var timeSlots = _objectSpread({}, parsedPartners.timeSlots);
  var gglocations = (0, _lodash.mapValues)(parsedGglocations, function (value) {
    return new _Gglocation["default"]({
      gglocation: value,
      allTimeSlots: timeSlots
    });
  });
  return {
    response: {
      gglocations: gglocations,
      storeIds: storeIds,
      partnerIds: partnerIds,
      timeSlots: timeSlots
    }
  };
}
function responseArrayToObject(_ref14) {
  var data = _ref14.data,
    endpointName = _ref14.endpointName;
  var newObj = {};
  data.response.map(function (property) {
    newObj[property.id] = property;
    return property;
  });
  return {
    response: _defineProperty({}, endpointName, newObj)
  };
}
function prepareImagesResponse(_ref15) {
  var data = _ref15.data,
    endpointName = _ref15.endpointName,
    state = _ref15.state;
  var images = responseArrayToObject({
    data: data,
    endpointName: endpointName
  });
  return {
    response: {
      imageData: _objectSpread(_objectSpread({}, state.imageData), images.response)
    }
  };
}
function prepareIngredientsResponse(_ref16) {
  var data = _ref16.data,
    state = _ref16.state;
  var ingredients = {};
  var ingredientNutrientAmounts = {};
  data.response.map(function (ingredient) {
    ingredients[ingredient.id] = _objectSpread(_objectSpread({}, ingredient), {}, {
      price: parseFloat(ingredient.price),
      servingWeight: parseFloat(ingredient.servingWeight),
      nutrientServingWeight: parseFloat(ingredient.nutrientServingWeight),
      nutrientsAmounts: ingredient.id
    });
    ingredient.nutrients.map(function (ingredientNutrient) {
      var nutrient = ingredientNutrient.nutrient,
        amount = ingredientNutrient.amount;
      ingredientNutrientAmounts[ingredient.id] = _objectSpread(_objectSpread({}, ingredientNutrientAmounts[ingredient.id]), {}, _defineProperty({}, nutrient, parseFloat(amount)));
      return ingredientNutrient;
    });
    return ingredient;
  });
  return {
    response: {
      ingredients: ingredients,
      ingredientNutrientAmounts: _objectSpread(_objectSpread({}, state.ingredientNutrientAmounts), ingredientNutrientAmounts)
    }
  };
}
function prepareGglocationMenuGroupsResponse(_ref17) {
  var data = _ref17.data;
  var gglocationMenuGroups = {};
  data.response.map(function (gglocation) {
    var gglocationId = "".concat(gglocation.gglocationType, "_").concat(gglocation.gglocationId);
    gglocationMenuGroups[gglocationId] = gglocation.menus;
    return gglocation;
  });
  return {
    response: {
      gglocationMenuGroups: gglocationMenuGroups
    }
  };
}
function prepareServingNumberVariationsResponse(_ref18) {
  var data = _ref18.data;
  var servingNumberVariations = data.response.map(function (servingNumberVariation) {
    return _objectSpread(_objectSpread({}, servingNumberVariation), {}, {
      menuUuid: servingNumberVariation.menuUuid || null,
      defaultServingNumber: parseFloat(servingNumberVariation.defaultServingNumber)
    });
  });
  return {
    response: {
      servingNumberVariations: servingNumberVariations
    }
  };
}
function prepareSettingsResponse(_ref19) {
  var data = _ref19.data,
    state = _ref19.state;
  var images = commonUtils.arrayToObject(data.response.webclientBannerImages);
  var displaySettings = commonUtils.arrayToObject(data.response.displaySettings);
  return {
    response: {
      imageData: _objectSpread(_objectSpread({}, state.imageData), {}, {
        bannerImages: _objectSpread({}, images)
      }),
      settings: _objectSpread(_objectSpread({}, data.response), {}, {
        displaySettings: displaySettings
      })
    }
  };
}
function preparePricingVariationsResponse(_ref20) {
  var data = _ref20.data;
  var pricingVariations = data.response.map(function (pricingVariation, id) {
    /* pricingVariation.limit acts as maximumServings with 1 minimumServings */
    var minimumServings = pricingVariation.limit ? 1.0 : parseFloat(pricingVariation.minimumServings) || null;
    var maximumServings = pricingVariation.limit ? parseFloat(pricingVariation.limit) : parseFloat(pricingVariation.maximumServings) || null;
    return _objectSpread(_objectSpread({}, pricingVariation), {}, {
      id: id,
      menuUuid: pricingVariation.menuUuid || null,
      price: parseFloat(pricingVariation.price),
      taxAmount: parseFloat(pricingVariation.taxAmount),
      serving: undefined,
      minimumServings: minimumServings,
      maximumServings: maximumServings
    });
  });
  return {
    response: {
      pricingVariations: pricingVariations
    }
  };
}
function prepareMenuGroupsResponse(_ref21) {
  var data = _ref21.data,
    state = _ref21.state;
  var menuItems = {};
  var menuItemIngredientServings = {};
  var apiIdMenuItemNames = {};
  var menuGroups = {};
  data.response.map(function (menuGroup) {
    var result = foodUtils.parseMenus(menuGroup.menus, menuGroup.id);
    menuGroups[menuGroup.id] = Object.keys(result.menuItems);
    menuItems = _objectSpread(_objectSpread({}, menuItems), result.menuItems);
    menuItemIngredientServings = _objectSpread(_objectSpread({}, menuItemIngredientServings), result.menuItemIngredientServings);
    apiIdMenuItemNames = _objectSpread(_objectSpread({}, apiIdMenuItemNames), result.apiIdMenuItemNames);
    return menuGroup;
  });
  return {
    response: {
      menuItems: _objectSpread(_objectSpread({}, state.menuItems), menuItems),
      menuItemIngredientServings: _objectSpread(_objectSpread({}, state.menuItemIngredientServings), menuItemIngredientServings),
      menuGroups: _objectSpread(_objectSpread({}, state.menuGroups), menuGroups),
      apiIdMenuItemNames: apiIdMenuItemNames
    }
  };
}
function prepareGetMenuGroupResponse(_ref22) {
  var data = _ref22.data,
    state = _ref22.state;
  var menuGroup = data.response;
  var result = foodUtils.parseMenus(menuGroup.menus, menuGroup.id);
  return {
    response: {
      menuGroups: _objectSpread(_objectSpread({}, state.menuGroups), {}, _defineProperty({}, menuGroup.id, Object.keys(result.menuItems))),
      menuItems: _objectSpread(_objectSpread({}, state.menuItems), result.menuItems),
      menuItemIngredientServings: _objectSpread(_objectSpread({}, state.menuItemIngredientServings), result.menuItemIngredientServings),
      apiIdMenuItemNames: _objectSpread(_objectSpread({}, state.apiIdMenuItemNames), result.apiIdMenuItemNames)
    }
  };
}
function prepareStoreBusyResponse(_ref23) {
  var data = _ref23.data,
    state = _ref23.state;
  var newStoreBusyDetails = (0, _lodash.keyBy)(data.response, "storeId");
  return {
    response: {
      storeBusyDetails: _objectSpread(_objectSpread({}, state.storeBusyDetails), newStoreBusyDetails)
    }
  };
}
function prepareLandingPageResponse(_ref24) {
  var data = _ref24.data;
  return {
    response: _objectSpread({}, data.response)
  };
}
function prepareNutritionalCalculationResponse(_ref25) {
  var data = _ref25.data;
  return {
    response: {
      nutrients: _objectSpread({}, foodUtils.parseNutrientAmounts(data.response.nutrients))
    }
  };
}